export const STRIPE_STATUSES_MAP = {
  all: 'all',
  incomplete: 'incomplete',
  incomplete_expired: 'incomplete_expired',
  active: 'active',
  past_due: 'past_due',
  canceled: 'canceled',
  trialing: 'trialing',
  unpaid: 'unpaid',
};

export const STRIPE_STATUS_PRETTY = {
  [STRIPE_STATUSES_MAP.all]: 'All',
  [STRIPE_STATUSES_MAP.incomplete]: 'Incomplete',
  [STRIPE_STATUSES_MAP.incomplete_expired]: 'Incomplete Expired',
  [STRIPE_STATUSES_MAP.active]: 'Active',
  [STRIPE_STATUSES_MAP.past_due]: 'Past Due',
  [STRIPE_STATUSES_MAP.canceled]: 'Canceled',
  [STRIPE_STATUSES_MAP.trialing]: 'Trialing',
  [STRIPE_STATUSES_MAP.unpaid]: 'Unpaid',
};

export const STRIPE_STATUSES = [
  { value: STRIPE_STATUSES_MAP.all },
  { value: STRIPE_STATUSES_MAP.incomplete },
  { value: STRIPE_STATUSES_MAP.incomplete_expired },
  { value: STRIPE_STATUSES_MAP.active },
  { value: STRIPE_STATUSES_MAP.past_due },
  { value: STRIPE_STATUSES_MAP.canceled },
  { value: STRIPE_STATUSES_MAP.trialing },
  { value: STRIPE_STATUSES_MAP.unpaid },
].map((i) => ({ ...i, name: STRIPE_STATUS_PRETTY[i.value] }));
